import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class Permission {
  async init() {
    return (await fetchApi.get(`${URL}/permission`)).data;
  }
}
